module.exports = __webpack_public_path__ + "static/img/user-default.1897f975.png";